import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import api from "../../../utils/axiosInstance";
import { btn } from "../../../components/Button/buttonStyles";
import SetupWizard from "./SetupWizard";

const SetupWizardPage = () => {
  const [loading, setLoading] = useState(true);
  const [setupCompleted, setSetupCompleted] = useState(false);

  useEffect(() => {
    const checkSetupStatus = async () => {
      try {
        const response = await api.get("/auth/me");
        setSetupCompleted(response.data.setup_completed);
      } catch (err) {
        console.error("Error fetching setup status:", err);
      } finally {
        setLoading(false);
      }
    };

    checkSetupStatus();
  }, []);

  const handleSubmit = async (data) => {
    console.log("Wizard data to submit:", data);

    try {
      const response = await api.patch("/admin/setup-completed");
      console.log(response.data);

      window.location.href = "/dashboard";
    } catch (err) {
      console.error("Error submitting wizard:", err);
    }
  };

  if (loading) {
    return <p className="text-center mt-10 text-[13px] text-gray-400">Loading...</p>;
  }

  if (!setupCompleted) {
    return <SetupWizard onSubmit={handleSubmit} />;
  }

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-white border border-gray-100 rounded-xl shadow-card px-6 py-10 text-center">
        <span className="mx-auto grid place-items-center w-12 h-12 rounded-full bg-success-100 text-success-800">
          <Check className="w-6 h-6" />
        </span>
        <h2 className="mt-4 text-lg font-semibold tracking-tight text-gray-900">Setup completed</h2>
        <p className="mt-1 text-[13px] text-gray-500">
          Your workspace is ready. You can update these values anytime under System Values.
        </p>
        <a href="/dashboard" className={btn("primary", "md", "mt-6")}>
          Go to Dashboard
        </a>
      </div>
    </div>
  );
};

export default SetupWizardPage;